// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"14a4526d","61":"f29f2a40","436":"4863b4cf","807":"d36e9f11"}[chunkId] + ".chunk.js";
};